import { render, staticRenderFns } from "./NextBtn.vue?vue&type=template&id=1a263662&scoped=true&"
import script from "./NextBtn.vue?vue&type=script&lang=js&"
export * from "./NextBtn.vue?vue&type=script&lang=js&"
import style0 from "./NextBtn.vue?vue&type=style&index=0&id=1a263662&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a263662",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
